import styled from 'styled-components';
import { Flex } from '@components/Flex';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';

export const MainWrapper = styled(Flex)``;

export const ContentWrapper = styled(Box)`
  margin: ${themeSpace(0)} auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const QuoteWrapper = styled(Box)`
  text-align: center;
  max-width: 663px;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const LogoWrapper = styled(Flex)`
  display: block;
  text-align: center;
  max-width: 1100px;
`;

export const CustomCloudImage = styled(CloudImage)`
  opacity: 0.5;
  width: fit-content;
  ${themeMediaQuery('below_sm')} {
    max-width: 90px;
  }
`;
